import React, {Component} from "react";

export default class RepoInsights extends Component {
    render() {
        return (
            <div>
                Repo insights
            </div>
        );
    }
}